import src from "IMAGE";
export default { src, width: 939, height: 656, blurWidth: 0, blurHeight: 0};
